import { useUserStatusContext } from '../context/UserStatus';

const CARE_MANAGER_ROLE_NAME = 'Hero Care Manager Role';

/**
 * True when the ACTIVE org grant is the front-line Care Manager role.
 *
 * This is the one distinction that can't be made from permission bits: Care Manager
 * and Care Manager Supervisor are both member-scoped (neither holds
 * ENT_FLEET_ORGANIZATION_VIEW) and both hold ENT_CARE_MANAGER_EDIT, so no modelled
 * boolean separates them. Everything else — who may edit a member, assign a Care
 * Manager, see the CM filter — must gate on `permissions`, not on this.
 *
 * Reads the active grant rather than `userStatus.role`, which reports the primary
 * org's role and is wrong for every other org the user holds.
 */
const useIsCareManager = () => {
    const { activeRole } = useUserStatusContext();

    return activeRole?.name === CARE_MANAGER_ROLE_NAME;
};

export default useIsCareManager;
